/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AssignedTodo,
  CreateTodoRequest,
  CreateTodoResponse,
  MyTodoCountsResponse,
  ReassignTodoRequest,
  SnoozeTodoRequest,
  Todo,
  UpdateTodoRequest,
} from "../models/index";
import {
  AssignedTodoFromJSON,
  AssignedTodoToJSON,
  CreateTodoRequestFromJSON,
  CreateTodoRequestToJSON,
  CreateTodoResponseFromJSON,
  CreateTodoResponseToJSON,
  MyTodoCountsResponseFromJSON,
  MyTodoCountsResponseToJSON,
  ReassignTodoRequestFromJSON,
  ReassignTodoRequestToJSON,
  SnoozeTodoRequestFromJSON,
  SnoozeTodoRequestToJSON,
  TodoFromJSON,
  TodoToJSON,
  UpdateTodoRequestFromJSON,
  UpdateTodoRequestToJSON,
} from "../models/index";

export interface CreateTodoOperationRequest {
  createTodoRequest: CreateTodoRequest;
}

export interface GetTodoByIdRequest {
  todoId: string;
}

export interface ListTodosByAssigneesRequest {
  assignees: Array<string>;
  includeTerminal?: boolean;
  includeSnoozed?: boolean;
}

export interface ListTodosForCarrierRequest {
  carrierIdentifier: string;
  includeTerminal?: boolean;
  includeSnoozed?: boolean;
}

export interface ListTodosForCompanyRequest {
  companyId: string;
  includeTerminal?: boolean;
  includeSnoozed?: boolean;
}

export interface MarkTodoCancelledRequest {
  todoId: string;
}

export interface MarkTodoDoneRequest {
  todoId: string;
}

export interface ReassignTodoOperationRequest {
  todoId: string;
  reassignTodoRequest: ReassignTodoRequest;
}

export interface ReopenTodoRequest {
  todoId: string;
}

export interface SnoozeTodoOperationRequest {
  todoId: string;
  snoozeTodoRequest: SnoozeTodoRequest;
}

export interface UpdateTodoOperationRequest {
  todoId: string;
  updateTodoRequest: UpdateTodoRequest;
}

/**
 *
 */
export class TodosApi extends runtime.BaseAPI {
  /**
   */
  async createTodoRaw(
    requestParameters: CreateTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CreateTodoResponse>> {
    if (requestParameters["createTodoRequest"] == null) {
      throw new runtime.RequiredError(
        "createTodoRequest",
        'Required parameter "createTodoRequest" was null or undefined when calling createTodo().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/todos/create`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateTodoRequestToJSON(requestParameters["createTodoRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreateTodoResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async createTodo(
    requestParameters: CreateTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CreateTodoResponse> {
    const response = await this.createTodoRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async getMyTodoCountsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MyTodoCountsResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/counts-for-me`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MyTodoCountsResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getMyTodoCounts(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MyTodoCountsResponse> {
    const response = await this.getMyTodoCountsRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async getTodoByIdRaw(
    requestParameters: GetTodoByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Todo>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling getTodoById().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TodoFromJSON(jsonValue),
    );
  }

  /**
   */
  async getTodoById(
    requestParameters: GetTodoByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Todo> {
    const response = await this.getTodoByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listTodosByAssigneesRaw(
    requestParameters: ListTodosByAssigneesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<AssignedTodo>>> {
    if (requestParameters["assignees"] == null) {
      throw new runtime.RequiredError(
        "assignees",
        'Required parameter "assignees" was null or undefined when calling listTodosByAssignees().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["assignees"] != null) {
      queryParameters["assignees"] = requestParameters["assignees"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["includeTerminal"] != null) {
      queryParameters["includeTerminal"] = requestParameters["includeTerminal"];
    }

    if (requestParameters["includeSnoozed"] != null) {
      queryParameters["includeSnoozed"] = requestParameters["includeSnoozed"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/by-assignees`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AssignedTodoFromJSON),
    );
  }

  /**
   */
  async listTodosByAssignees(
    requestParameters: ListTodosByAssigneesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<AssignedTodo>> {
    const response = await this.listTodosByAssigneesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listTodosForCarrierRaw(
    requestParameters: ListTodosForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Todo>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling listTodosForCarrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["includeTerminal"] != null) {
      queryParameters["includeTerminal"] = requestParameters["includeTerminal"];
    }

    if (requestParameters["includeSnoozed"] != null) {
      queryParameters["includeSnoozed"] = requestParameters["includeSnoozed"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/for-carrier`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TodoFromJSON),
    );
  }

  /**
   */
  async listTodosForCarrier(
    requestParameters: ListTodosForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Todo>> {
    const response = await this.listTodosForCarrierRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async listTodosForCompanyRaw(
    requestParameters: ListTodosForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<Todo>>> {
    if (requestParameters["companyId"] == null) {
      throw new runtime.RequiredError(
        "companyId",
        'Required parameter "companyId" was null or undefined when calling listTodosForCompany().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyId"] != null) {
      queryParameters["companyId"] = requestParameters["companyId"];
    }

    if (requestParameters["includeTerminal"] != null) {
      queryParameters["includeTerminal"] = requestParameters["includeTerminal"];
    }

    if (requestParameters["includeSnoozed"] != null) {
      queryParameters["includeSnoozed"] = requestParameters["includeSnoozed"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/for-company`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(TodoFromJSON),
    );
  }

  /**
   */
  async listTodosForCompany(
    requestParameters: ListTodosForCompanyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<Todo>> {
    const response = await this.listTodosForCompanyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async markTodoCancelledRaw(
    requestParameters: MarkTodoCancelledRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling markTodoCancelled().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}/mark-cancelled`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markTodoCancelled(
    requestParameters: MarkTodoCancelledRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markTodoCancelledRaw(requestParameters, initOverrides);
  }

  /**
   */
  async markTodoDoneRaw(
    requestParameters: MarkTodoDoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling markTodoDone().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}/mark-done`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markTodoDone(
    requestParameters: MarkTodoDoneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markTodoDoneRaw(requestParameters, initOverrides);
  }

  /**
   */
  async reassignTodoRaw(
    requestParameters: ReassignTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling reassignTodo().',
      );
    }

    if (requestParameters["reassignTodoRequest"] == null) {
      throw new runtime.RequiredError(
        "reassignTodoRequest",
        'Required parameter "reassignTodoRequest" was null or undefined when calling reassignTodo().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}/reassign`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ReassignTodoRequestToJSON(
          requestParameters["reassignTodoRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async reassignTodo(
    requestParameters: ReassignTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.reassignTodoRaw(requestParameters, initOverrides);
  }

  /**
   */
  async reopenTodoRaw(
    requestParameters: ReopenTodoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling reopenTodo().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}/reopen`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async reopenTodo(
    requestParameters: ReopenTodoRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.reopenTodoRaw(requestParameters, initOverrides);
  }

  /**
   */
  async snoozeTodoRaw(
    requestParameters: SnoozeTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling snoozeTodo().',
      );
    }

    if (requestParameters["snoozeTodoRequest"] == null) {
      throw new runtime.RequiredError(
        "snoozeTodoRequest",
        'Required parameter "snoozeTodoRequest" was null or undefined when calling snoozeTodo().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}/snooze`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SnoozeTodoRequestToJSON(requestParameters["snoozeTodoRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async snoozeTodo(
    requestParameters: SnoozeTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.snoozeTodoRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateTodoRaw(
    requestParameters: UpdateTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["todoId"] == null) {
      throw new runtime.RequiredError(
        "todoId",
        'Required parameter "todoId" was null or undefined when calling updateTodo().',
      );
    }

    if (requestParameters["updateTodoRequest"] == null) {
      throw new runtime.RequiredError(
        "updateTodoRequest",
        'Required parameter "updateTodoRequest" was null or undefined when calling updateTodo().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/todos/{todoId}/update`.replace(
          `{${"todoId"}}`,
          encodeURIComponent(String(requestParameters["todoId"])),
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateTodoRequestToJSON(requestParameters["updateTodoRequest"]),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateTodo(
    requestParameters: UpdateTodoOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateTodoRaw(requestParameters, initOverrides);
  }
}
